(function () {
  var cfg = window.__toserofToptan;
  if (!cfg || !cfg.apiBase || !cfg.shop) return;

  var DEPO = 'tsrf:' + cfg.shop;
  var YIL = 365 * 24 * 60 * 60 * 1000;
  var TAZELIK = 5 * 60 * 1000;
  var durum = null;
  var overlay = null;
  var scrollDinleyici = null;

  function depoOku() {
    try {
      var ham = localStorage.getItem(DEPO);
      if (!ham) return null;
      var veri = JSON.parse(ham);
      var omur = veri.state === 'red_kalici' ? YIL : TAZELIK;
      if (Date.now() - (veri.ts || 0) > omur) return null;
      return veri;
    } catch (err) {
      return null;
    }
  }

  function depoYaz(veri) {
    try {
      veri.ts = Date.now();
      localStorage.setItem(DEPO, JSON.stringify(veri));
    } catch (err) {
      return;
    }
  }

  function kimlikParametreleri() {
    var p = ['shop=' + encodeURIComponent(cfg.shop)];
    if (cfg.customerId) {
      p.push('customer_id=' + encodeURIComponent(cfg.customerId));
      if (cfg.customerEmail) p.push('email=' + encodeURIComponent(cfg.customerEmail));
    } else {
      var onbellek = depoOku() || {};
      if (onbellek.token) p.push('token=' + encodeURIComponent(onbellek.token));
    }
    return p.join('&');
  }

  function durumGetir() {
    return fetch(cfg.apiBase + '/api/wholesale/status?' + kimlikParametreleri(), {
      method: 'GET',
      headers: { Accept: 'application/json' },
    }).then(function (r) {
      return r.json();
    });
  }

  function serbestMi(d) {
    return !d || d.enabled === false || d.state === 'kapali' || d.state === 'onayli';
  }

  function kilitUygula(d) {
    document.body.classList.toggle('tsrf-gated', !serbestMi(d));
  }

  function sayfaTipi() {
    return (cfg.pageType || '').toLowerCase();
  }

  function anaSayfaSerbest(d) {
    return d.homepageOpen !== false && sayfaTipi() === 'index';
  }

  function overlayOlustur() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'tsrf-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    document.body.appendChild(overlay);
    return overlay;
  }

  function overlayAc(icerik) {
    var el = overlayOlustur();
    var dar = icerik && icerik.dar ? ' tsrf-modal--narrow' : '';
    var html = icerik && icerik.html ? icerik.html : String(icerik || '');
    el.innerHTML = '<div class="tsrf-modal' + dar + '" lang="tr">' + html + '</div>';
    el.classList.add('is-open');
    el.scrollTop = 0;
    document.body.classList.add('tsrf-locked-scroll');
    document.addEventListener('keydown', escEngelle, true);
  }

  function overlayKapat() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.classList.remove('tsrf-locked-scroll');
    document.removeEventListener('keydown', escEngelle, true);
  }

  function escEngelle(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  function kacir(metin) {
    var d = document.createElement('div');
    d.textContent = metin == null ? '' : String(metin);
    return d.innerHTML;
  }

  var IKON = {
    onay: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>',
    saat: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><polyline points="12 7 12 12 15 14"></polyline></svg>',
    kilit: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="10" width="16" height="11" rx="2"></rect><path d="M8 10V7a4 4 0 0 1 8 0v3"></path></svg>',
    bilgi: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><path d="M12 11v5"></path><path d="M12 8h.01"></path></svg>',
    ekle: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 16V4"></path><path d="m7 9 5-5 5 5"></path><path d="M4 17v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2"></path></svg>',
    belge: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3H7a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7z"></path><path d="M14 3v4h4"></path><path d="m9 15 2 2 4-4"></path></svg>',
  };

  function modalKur(o) {
    var head = '<div class="tsrf-head' + (o.duzKenar ? ' tsrf-head--plain' : '') + '">'
      + (o.ustBaslik ? '<div class="tsrf-eyebrow">' + kacir(o.ustBaslik) + '</div>' : '')
      + '<h2 class="tsrf-title">' + kacir(o.baslik) + '</h2>'
      + (o.altMetin ? '<p class="tsrf-sub">' + kacir(o.altMetin) + '</p>' : '')
      + '</div>';
    return { dar: !!o.dar, html: head + '<div class="tsrf-body">' + o.govde + '</div>' };
  }

  function notKutusu(baslik, metin) {
    return '<div class="tsrf-note"><span class="tsrf-note__icon">' + IKON.bilgi + '</span><span>'
      + (baslik ? '<strong>' + kacir(baslik) + '</strong>' : '') + kacir(metin) + '</span></div>';
  }

  function adimlar(aktif) {
    var liste = [['Hesap', 1], ['Başvuru', 2], ['Onay', 3]];
    return '<div class="tsrf-steps">' + liste.map(function (a) {
      var durum = a[1] < aktif ? ' tsrf-step--done' : (a[1] === aktif ? ' tsrf-step--active' : '');
      var isaret = a[1] < aktif ? IKON.onay : String(a[1]);
      var aciklama = { 1: 'Hesabınızla giriş yapın', 2: 'Bilgilerinizi iletin', 3: 'Onay sonrası katalog açılır' }[a[1]];
      return '<div class="tsrf-step' + durum + '"><span class="tsrf-step__no">' + isaret + '</span><span>' + kacir(aciklama) + '</span></div>';
    }).join('') + '</div>';
  }

  function girisIcerigi() {
    var govde = '<div class="tsrf-center"><span class="tsrf-mark tsrf-mark--wait">' + IKON.kilit + '</span></div>'
      + adimlar(1)
      + '<div class="tsrf-submit">'
      + '<div class="tsrf-actions">'
      + '<a class="tsrf-btn tsrf-btn--primary" href="' + kacir(cfg.loginUrl) + '">Giriş Yap</a>'
      + '<a class="tsrf-btn tsrf-btn--ghost" href="' + kacir(cfg.registerUrl) + '">Üye Ol</a>'
      + '</div>'
      + '<p class="tsrf-hint">Üyelik ücretsizdir, onay sonrası toptan fiyatlar hesabınıza açılır.</p>'
      + '</div>';
    return modalKur({
      dar: true,
      duzKenar: true,
      ustBaslik: 'Toptan Satış',
      baslik: 'Ürünleri görmek için giriş yapın',
      altMetin: 'Bu mağaza yalnızca onaylı toptan müşterilerine açıktır.',
      govde: govde,
    });
  }

  function tipSecili(d) {
    return d.accountTypeEnabled && d.accountType === 'sahis' ? 'sahis' : 'kurumsal';
  }

  function alanGorunur(f, tip) {
    var kitle = f.audience || 'all';
    return kitle === 'all' || kitle === tip;
  }

  function alanEtiketi(f, tip) {
    return tip === 'sahis' && f.individualLabel ? f.individualLabel : f.label;
  }

  function tipSecici(d) {
    if (!d.accountTypeEnabled) return '';
    var tip = tipSecili(d);
    var secenek = function (deger, ad, aciklama) {
      return '<label class="tsrf-seg__item">'
        + '<input type="radio" name="accountType" value="' + deger + '"' + (tip === deger ? ' checked' : '') + '>'
        + '<span class="tsrf-seg__box"><span class="tsrf-seg__name">' + ad + '</span><span class="tsrf-seg__desc">' + aciklama + '</span></span>'
        + '</label>';
    };
    return '<div class="tsrf-field tsrf-field--full"><span class="tsrf-label">Üyelik Tipi</span>'
      + '<div class="tsrf-seg" role="radiogroup" aria-label="Üyelik Tipi">'
      + secenek('kurumsal', 'Kurumsal', 'Şirket adına, vergi bilgileriyle')
      + secenek('sahis', 'Şahıs', 'Bireysel, vergi bilgisi istenmez')
      + '</div></div>';
  }

  function formIcerigi(d) {
    var tip = tipSecili(d);
    var alanlar = tipSecici(d) + (d.formFields || []).map(function (f) {
      var etiket = '<label class="tsrf-label" for="tsrf-' + kacir(f.key) + '"><span class="tsrf-label__text" data-etiket="' + kacir(f.key) + '">' + kacir(alanEtiketi(f, tip)) + '</span>'
        + (f.required ? '' : ' <span>(isteğe bağlı)</span>') + '</label>';
      var girdi;
      if (f.type === 'select') {
        girdi = '<select class="tsrf-select" id="tsrf-' + kacir(f.key) + '" name="' + kacir(f.key) + '"'
          + (f.required ? ' required' : '') + '><option value="">Seçiniz</option>'
          + (f.options || []).map(function (o) { return '<option value="' + kacir(o) + '">' + kacir(o) + '</option>'; }).join('')
          + '</select>';
      } else if (f.type === 'file') {
        girdi = '<div class="tsrf-file">'
          + '<input type="file" id="tsrf-' + kacir(f.key) + '" name="' + kacir(f.key) + '" accept=".pdf,image/*"'
          + (f.required ? ' required' : '') + ' data-alan="' + kacir(f.key) + '">'
          + '<label class="tsrf-drop" for="tsrf-' + kacir(f.key) + '" data-drop="' + kacir(f.key) + '">'
          + '<span class="tsrf-drop__icon">' + IKON.ekle + '</span>'
          + '<span class="tsrf-drop__text"><span class="tsrf-drop__name">'
          + kacir(f.placeholder || 'PDF veya fotoğraf seçin') + '</span></span>'
          + '<button type="button" class="tsrf-drop__clear" data-temizle="' + kacir(f.key) + '" aria-label="Dosyayı kaldır">&times;</button>'
          + '</label></div>';
      } else {
        girdi = '<input class="tsrf-input" id="tsrf-' + kacir(f.key) + '" name="' + kacir(f.key) + '" type="' + kacir(f.type || 'text') + '"'
          + (f.required ? ' required' : '') + ' placeholder="' + kacir(f.placeholder) + '">';
      }
      var genis = (f.width || 'full') === 'full';
      return '<div class="tsrf-field' + (genis ? ' tsrf-field--full' : '') + (alanGorunur(f, tip) ? '' : ' tsrf-field--hidden') + '" data-kitle="' + kacir(f.audience || 'all') + '" data-alan-kutu="' + kacir(f.key) + '">' + etiket + girdi + '</div>';
    }).join('');

    var duzeltme = d.state === 'red_duzeltilebilir' && d.rejectionReason;
    var govde = (duzeltme ? notKutusu('Düzeltme gerekiyor', d.rejectionReason) : '')
      + '<form class="tsrf-form" id="tsrf-form" novalidate>' + alanlar
      + '<div class="tsrf-error" id="tsrf-error"></div>'
      + '<div class="tsrf-submit">'
      + '<button type="submit" class="tsrf-btn tsrf-btn--primary tsrf-btn--full">Başvuruyu Gönder</button>'
      + '<p class="tsrf-hint" data-belge-notu>Belgeler yalnızca başvuru değerlendirmesi için kullanılır. En fazla 10 MB, PDF veya fotoğraf.</p>'
      + '</div></form>';

    return modalKur({
      ustBaslik: duzeltme ? 'Başvuru Düzeltme' : 'Toptan Başvurusu',
      baslik: duzeltme ? 'Başvurunuzu güncelleyin' : 'Toptan hesap başvurusu',
      altMetin: duzeltme
        ? 'Eksik bilgileri tamamlayıp yeniden gönderin.'
        : 'Bilgilerinizi bırakın; onayladığımızda ürünler ve toptan fiyatlar hesabınıza açılır.',
      govde: govde,
    });
  }

  function beklemedeIcerigi() {
    var govde = '<div class="tsrf-center"><span class="tsrf-mark tsrf-mark--wait">' + IKON.saat + '</span></div>'
      + adimlar(3)
      + '<div class="tsrf-submit">'
      + '<a class="tsrf-btn tsrf-btn--ghost tsrf-btn--full" href="' + kacir(cfg.accountUrl) + '">Hesabıma Git</a>'
      + '<p class="tsrf-hint">Sonuç e-posta ile bildirilecek.</p>'
      + '</div>';
    return modalKur({
      dar: true,
      duzKenar: true,
      ustBaslik: 'İnceleniyor',
      baslik: 'Başvurunuz incelemede',
      altMetin: 'Başvurunuz ekibimize ulaştı. Değerlendirme tamamlandığında ürünler ve fiyatlar hesabınıza açılacak.',
      govde: govde,
    });
  }

  function redIcerigi(d) {
    var govde = '<div class="tsrf-center"><span class="tsrf-mark tsrf-mark--stop">' + IKON.kilit + '</span></div>'
      + (d.rejectionReason ? notKutusu('Değerlendirme notu', d.rejectionReason) : '')
      + '<div class="tsrf-submit">'
      + '<a class="tsrf-btn tsrf-btn--ghost tsrf-btn--full" href="' + kacir(cfg.contactUrl) + '">İletişime Geç</a>'
      + '<p class="tsrf-hint">Koşullar değiştiğinde yeniden değerlendirme talep edebilirsiniz.</p>'
      + '</div>';
    return modalKur({
      dar: true,
      duzKenar: true,
      ustBaslik: 'Başvuru Sonucu',
      baslik: 'Başvurunuz onaylanmadı',
      altMetin: 'Toptan satış koşullarımızı şu anda karşılamadığınız için mağaza içeriği hesabınıza açılmadı.',
      govde: govde,
    });
  }

  function basariIcerigi() {
    var govde = '<div class="tsrf-center"><span class="tsrf-mark tsrf-mark--ok">' + IKON.onay + '</span></div>'
      + adimlar(3)
      + '<div class="tsrf-submit">'
      + '<a class="tsrf-btn tsrf-btn--ghost tsrf-btn--full" href="' + kacir(cfg.accountUrl) + '">Hesabıma Git</a>'
      + '<p class="tsrf-hint">Sonuç e-posta ile bildirilecek.</p>'
      + '</div>';
    return modalKur({
      dar: true,
      duzKenar: true,
      ustBaslik: 'Teşekkürler',
      baslik: 'Başvurunuz alındı',
      altMetin: 'Başvurunuz incelemeye alındı. Onaylandığında ürünler ve toptan fiyatlar hesabınıza açılacak.',
      govde: govde,
    });
  }

  function boyutYaz(bayt) {
    if (bayt >= 1048576) return (bayt / 1048576).toFixed(1).replace('.', ',') + ' MB';
    return Math.max(1, Math.round(bayt / 1024)) + ' KB';
  }

  function dosyaAlanlariniBagla(form, d) {
    var MAKS = 10 * 1024 * 1024;
    (d.formFields || []).filter(function (f) { return f.type === 'file'; }).forEach(function (f) {
      var girdi = form.querySelector('input[type="file"][data-alan="' + f.key + '"]');
      var kutu = form.querySelector('[data-drop="' + f.key + '"]');
      if (!girdi || !kutu) return;
      var ikon = kutu.querySelector('.tsrf-drop__icon');
      var yazi = kutu.querySelector('.tsrf-drop__text');
      var temizle = kutu.querySelector('[data-temizle]');
      var varsayilan = f.placeholder || 'PDF veya fotoğraf seçin';
      var yuklu = (d.existingDocuments || []).filter(function (b) { return b.key === f.key; })[0];

      if (yuklu) {
        kutu.classList.add('is-filled');
        ikon.innerHTML = IKON.belge;
        yazi.innerHTML = '<span class="tsrf-drop__name">' + kacir(yuklu.originalName || 'Yüklenmiş belge') + '</span>'
          + '<span class="tsrf-drop__size">Yüklü &middot; değiştirmek için seçin</span>';
        girdi.removeAttribute('required');
      }

      function sifirla() {
        girdi.value = '';
        kutu.classList.remove('is-filled', 'is-error');
        ikon.innerHTML = IKON.ekle;
        yazi.innerHTML = '<span class="tsrf-drop__name">' + kacir(varsayilan) + '</span>';
      }

      girdi.addEventListener('change', function () {
        var dosya = girdi.files && girdi.files[0];
        if (!dosya) return sifirla();
        if (dosya.size > MAKS) {
          kutu.classList.add('is-error');
          yazi.innerHTML = '<span class="tsrf-drop__name">Dosya 10 MB sınırını aşıyor</span>';
          girdi.value = '';
          return;
        }
        kutu.classList.remove('is-error');
        kutu.classList.add('is-filled');
        ikon.innerHTML = IKON.belge;
        yazi.innerHTML = '<span class="tsrf-drop__name">' + kacir(dosya.name) + '</span>'
          + '<span class="tsrf-drop__size">' + boyutYaz(dosya.size) + '</span>';
      });

      if (temizle) {
        temizle.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          sifirla();
        });
      }
    });
  }

  function formBagla(d) {
    var form = document.getElementById('tsrf-form');
    if (!form) return;
    dosyaAlanlariniBagla(form, d);

    function aktifTip() {
      if (!d.accountTypeEnabled) return 'kurumsal';
      var secili = form.querySelector('input[name="accountType"]:checked');
      return secili && secili.value === 'sahis' ? 'sahis' : 'kurumsal';
    }

    function tipUygula() {
      var tip = aktifTip();
      (d.formFields || []).forEach(function (f) {
        var kutu = form.querySelector('[data-alan-kutu="' + f.key + '"]');
        if (!kutu) return;
        kutu.classList.toggle('tsrf-field--hidden', !alanGorunur(f, tip));
        var yazi = kutu.querySelector('[data-etiket]');
        if (yazi) yazi.textContent = alanEtiketi(f, tip);
      });
      var belgeNotu = form.querySelector('[data-belge-notu]');
      if (belgeNotu) {
        var belgeVar = (d.formFields || []).some(function (f) { return f.type === 'file' && alanGorunur(f, tip); });
        belgeNotu.style.display = belgeVar ? '' : 'none';
      }
      form.querySelectorAll('.is-error').forEach(function (el) { el.classList.remove('is-error'); });
      var hata = document.getElementById('tsrf-error');
      if (hata) hata.classList.remove('is-visible');
    }

    form.querySelectorAll('input[name="accountType"]').forEach(function (el) {
      el.addEventListener('change', tipUygula);
    });
    tipUygula();

    form.addEventListener('input', function (e) {
      if (e.target && e.target.classList) e.target.classList.remove('is-error');
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var hataKutusu = document.getElementById('tsrf-error');
      var buton = form.querySelector('button[type="submit"]');
      var tip = aktifTip();
      var alanlar = {};
      var eksik = null;
      if (d.accountTypeEnabled) alanlar.accountType = tip;

      (d.formFields || []).forEach(function (f) {
        if (!alanGorunur(f, tip)) return;
        var etiket = alanEtiketi(f, tip);
        var el = form.querySelector('[name="' + f.key + '"]');
        if (!el) return;
        if (f.type === 'file') {
          var secili = el.files && el.files[0];
          var zatenVar = (d.existingDocuments || []).some(function (b) { return b.key === f.key; });
          if (f.required && !secili && !zatenVar) {
            if (!eksik) eksik = etiket + ' belgesini yükleyin';
            var kutu = form.querySelector('[data-drop="' + f.key + '"]');
            if (kutu) kutu.classList.add('is-error');
          }
          return;
        }
        var deger = String(el.value || '').trim();
        if (f.required && !deger) {
          if (!eksik) eksik = etiket + ' alanını doldurun';
          el.classList.add('is-error');
        } else if (deger && f.key === 'taxNumber' && !/^\d{10,11}$/.test(deger.replace(/\s/g, ''))) {
          if (!eksik) eksik = etiket + ' 10 ya da 11 haneli olmalı';
          el.classList.add('is-error');
        }
        alanlar[f.key] = deger;
      });

      if (eksik) {
        hataKutusu.textContent = eksik;
        hataKutusu.classList.add('is-visible');
        return;
      }

      buton.disabled = true;
      buton.textContent = 'Gönderiliyor...';
      hataKutusu.classList.remove('is-visible');

      var govde = new FormData();
      govde.append('fields', JSON.stringify(alanlar));
      if (cfg.customerId) {
        govde.append('customer_id', cfg.customerId);
        govde.append('email', cfg.customerEmail || '');
      } else {
        govde.append('token', (depoOku() || {}).token || '');
      }
      (d.formFields || []).filter(function (f) { return f.type === 'file' && alanGorunur(f, tip); }).forEach(function (f) {
        var el = form.querySelector('input[type="file"][name="' + f.key + '"]');
        if (el && el.files && el.files[0]) govde.append(f.key, el.files[0], el.files[0].name);
      });

      fetch(cfg.apiBase + '/api/wholesale/apply?shop=' + encodeURIComponent(cfg.shop), {
        method: 'POST',
        body: govde,
      }).then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, veri: j }; });
      }).then(function (sonuc) {
        if (!sonuc.ok) throw new Error(sonuc.veri.error || 'Başvuru gönderilemedi');
        depoYaz({ state: 'beklemede', token: (depoOku() || {}).token });
        overlayAc(basariIcerigi());
      }).catch(function (err) {
        buton.disabled = false;
        buton.textContent = 'Başvuruyu Gönder';
        hataKutusu.textContent = err.message;
        hataKutusu.classList.add('is-visible');
      });
    });
  }

  function scrollTetikleyici(d, icerik) {
    if (scrollDinleyici) return;
    var esik = Number(d.collectionScrollTrigger || 500);
    scrollDinleyici = function () {
      if (window.scrollY < esik) return;
      window.removeEventListener('scroll', scrollDinleyici);
      scrollDinleyici = null;
      overlayAc(icerik);
    };
    window.addEventListener('scroll', scrollDinleyici, { passive: true });
  }

  function uygula(d) {
    durum = d;
    kilitUygula(d);
    if (serbestMi(d)) {
      overlayKapat();
      return;
    }

    var tip = sayfaTipi();

    if (d.state === 'red_kalici') {
      overlayAc(redIcerigi(d));
      return;
    }
    if (d.state === 'red_duzeltilebilir') {
      overlayAc(formIcerigi(d));
      formBagla(d);
      return;
    }
    if (d.state === 'beklemede') {
      overlayAc(beklemedeIcerigi());
      return;
    }
    if (d.state === 'yok') {
      overlayAc(formIcerigi(d));
      formBagla(d);
      return;
    }

    if (d.state === 'misafir') {
      if (anaSayfaSerbest(d)) return;
      if (tip === 'collection' || tip === 'list-collections' || tip === 'search') {
        scrollTetikleyici(d, girisIcerigi());
        return;
      }
      overlayAc(girisIcerigi());
    }
  }

  function sepetEngelle() {
    var yerliFetch = window.fetch;
    window.fetch = function (girdi, secenekler) {
      var url = typeof girdi === 'string' ? girdi : (girdi && girdi.url) || '';
      if (durum && !serbestMi(durum) && /\/cart\/add/.test(url)) {
        return Promise.resolve(new Response(JSON.stringify({
          status: 422,
          message: 'Toptan onayı gerekli',
          description: 'Sepete ekleyebilmek için toptan başvurunuzun onaylanması gerekir.',
        }), {
          status: 422,
          headers: { 'Content-Type': 'application/json' },
        }));
      }
      return yerliFetch.apply(this, arguments);
    };

    document.addEventListener('submit', function (e) {
      if (!durum || serbestMi(durum)) return;
      var form = e.target;
      if (form && /\/cart\/add/.test(form.getAttribute('action') || '')) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  function baslat() {
    var onbellek = depoOku();
    if (onbellek && onbellek.state) {
      uygula({
        enabled: true,
        state: onbellek.state,
        homepageOpen: onbellek.homepageOpen,
        collectionScrollTrigger: onbellek.collectionScrollTrigger,
        rejectionReason: onbellek.rejectionReason,
        formFields: onbellek.formFields,
        accountTypeEnabled: onbellek.accountTypeEnabled,
        accountType: onbellek.accountType,
      });
    } else {
      document.body.classList.add('tsrf-gated');
    }

    sepetEngelle();

    durumGetir().then(function (d) {
      if (!d) return;
      depoYaz({
        state: d.state,
        token: d.token || (depoOku() || {}).token,
        homepageOpen: d.homepageOpen,
        collectionScrollTrigger: d.collectionScrollTrigger,
        rejectionReason: d.rejectionReason,
        formFields: d.formFields,
        accountTypeEnabled: d.accountTypeEnabled,
        accountType: d.accountType,
      });
      uygula(d);
    }).catch(function () {
      document.body.classList.remove('tsrf-gated');
      overlayKapat();
    });
  }

  if (document.body) {
    baslat();
  } else {
    document.addEventListener('DOMContentLoaded', baslat);
  }
})();
